import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';
import { getArticlesByCategory, getCategoryBySlug } from '@/mocks/articles';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const { t } = useTranslation();
  const category = getCategoryBySlug(slug || '');
  const categoryArticles = getArticlesByCategory(slug || '');

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="flex flex-col items-center justify-center h-screen text-center px-4 pt-16">
          <i className="ri-error-warning-line text-5xl text-foreground-400 mb-4"></i>
          <h1 className="text-2xl font-bold text-foreground-900">分类不存在</h1>
          <Link to="/" className="mt-4 text-primary-600 hover:text-primary-700 cursor-pointer">返回首页</Link>
        </div>
        <Footer />
      </>
    );
  }

  const webPageSchema = {
    name: `${category.name} - 黑料吃瓜在线`,
    url: `http://hngzxny.cn/category/${category.slug}`,
    isPartOf: { '@type': 'WebSite', name: '黑料吃瓜在线' },
  };

  const breadcrumbSchema = {
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'http://hngzxny.cn/' },
      { '@type': 'ListItem', position: 2, name: category.name, item: `http://hngzxny.cn/category/${category.slug}` },
    ],
  };

  return (
    <>
      <SchemaOrg type="WebPage" data={webPageSchema} />
      <SchemaOrg type="BreadcrumbList" data={breadcrumbSchema} />

      <main>
        <Navbar />

        <header className="relative w-full h-[320px] md:h-[420px] overflow-hidden mt-16">
          <img
            src="https://readdy.ai/api/search-image?query=Entertainment%20media%20collage%20with%20vibrant%20colors%20and%20dynamic%20composition%2C%20celebrity%20gossip%20and%20variety%20show%20themed%20visuals%20with%20modern%20design%2C%20warm%20atmospheric%20lighting%2C%20abstract%20entertainment%20background%2C%20soft%20gradients%20and%20flowing%20shapes%2C%20creative%20editorial%20style%2C%20cinematic%20look&width=1600&height=600&seq=category-hero-entertainment&orientation=landscape"
            alt={category.name}
            title={`${category.name} - 黑料吃瓜在线`}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/50"></div>

          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
            <span className="w-14 h-14 rounded-full bg-accent-500/90 flex items-center justify-center mb-5">
              <i className={`${category.icon} text-2xl text-background-50`}></i>
            </span>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50">
              {category.name}
            </h1>
            <p className="mt-3 text-base text-background-50/75">{category.description}</p>
          </div>
        </header>

        <section className="py-10 md:py-16 px-4 md:px-6">
          <div className="max-w-[1280px] mx-auto">
            <Breadcrumb items={[{ label: category.name }]} />

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {categoryArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>

            {categoryArticles.length === 0 && (
              <div className="text-center py-20">
                <i className="ri-inbox-line text-5xl text-foreground-300 mb-4"></i>
                <p className="text-foreground-500">该分类下暂无文章</p>
              </div>
            )}
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}